import { ELocalStorageKeys } from '@/features/store/ELocalStorageKeys';
import { v4 as uuidv4 } from 'uuid';

/**
 * Универсальная функция для получения Install ID через куки
 * Работает и на клиенте, и на сервере (Nuxt 3)
 */
export const getInstallId = (): string => {
  // Проверяем, доступен ли Nuxt context
  try {
    const installIdCookie = useCookie<string>(ELocalStorageKeys.MM__INSTALL_ID, {
      maxAge: 60 * 60 * 24 * 365 * 10, // 10 лет
      sameSite: 'lax',
      path: '/',
    });

    // Если installId уже есть в куках — возвращаем
    if (installIdCookie.value) {
      return installIdCookie.value;
    }

    // Если нет в куках, и мы на клиенте — пробуем взять из localStorage
    if (import.meta.client) {
      try {
        const fromLocalStorage = localStorage.getItem(ELocalStorageKeys.MM__INSTALL_ID);
        if (fromLocalStorage) {
          const parsed = JSON.parse(fromLocalStorage);
          installIdCookie.value = parsed;
          return parsed;
        }
      } catch (e) {
        // ignore
      }
    }

    // Если не нашли — генерируем новый
    const newInstallId = uuidv4();
    installIdCookie.value = newInstallId;
    return newInstallId;
  } catch (error) {
    // Если useCookie недоступен, работаем только с localStorage на клиенте
    if (import.meta.client) {
      try {
        const fromLocalStorage = localStorage.getItem(ELocalStorageKeys.MM__INSTALL_ID);
        if (fromLocalStorage) {
          return JSON.parse(fromLocalStorage);
        }
      } catch (e) {
        // ignore
      }
    }
    
    // Возвращаем временный ID или генерируем новый
    return uuidv4();
  }
};